var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrestigeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 243.654,
    height: 71.13,
    viewBox: "0 0 243.654 71.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31142",
    "data-name": "Group 31142",
    transform: "translate(-800.5 -1180.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24945",
    "data-name": "Group 24945",
    transform: "translate(801 1181.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24909",
    "data-name": "Group 24909",
    transform: "translate(54.291 8.342)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2934",
    "data-name": "Rectangle 2934",
    width: 1.667,
    height: 22.379,
    transform: "translate(0 1.357)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24865",
    "data-name": "Group 24865",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24946",
    "data-name": "Group 24946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75231",
    "data-name": "Path 75231",
    d: "M5.644,18.5H0V.941H5.644a8.781,8.781,0,1,1,0,17.562M1.667,16.836H5.644a7.114,7.114,0,1,0,0-14.229H1.667Z",
    transform: "translate(0 -0.418)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75232",
    "data-name": "Path 75232",
    d: "M52.882,18.5H47.239V.941h5.643a8.781,8.781,0,1,1,0,17.562m-3.977-1.667h3.977a7.114,7.114,0,1,0,0-14.229H48.906Z",
    transform: "translate(-20.995 -0.418)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2935",
    "data-name": "Rectangle 2935",
    width: 1.667,
    height: 9.83,
    transform: "translate(26.244 13.906)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75233",
    "data-name": "Path 75233",
    d: "M109.571,24.778H94.305V1.882h14.115V3.549H95.972V23.111h13.6Z",
    transform: "translate(-41.912 -0.836)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2936",
    "data-name": "Rectangle 2936",
    width: 12.445,
    height: 1.667,
    transform: "translate(53.227 14.432)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75234",
    "data-name": "Path 75234",
    d: "M327.735,24.778H312.469V1.882h14.115V3.549H314.136V23.111h13.6Z",
    transform: "translate(-138.871 -0.836)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2937",
    "data-name": "Rectangle 2937",
    width: 12.445,
    height: 1.667,
    transform: "translate(174.432 14.432)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2938",
    "data-name": "Rectangle 2938",
    width: 16.209,
    height: 1.667,
    transform: "translate(100.286 0.523)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2939",
    "data-name": "Rectangle 2939",
    width: 1.667,
    height: 22.379,
    transform: "translate(107.558 1.357)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2940",
    "data-name": "Rectangle 2940",
    width: 1.667,
    height: 22.379,
    transform: "translate(127.793 1.357)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75235",
    "data-name": "Path 75235",
    d: "M266,24.15a12.076,12.076,0,1,1,8.253-20.89l-1.139,1.217A10.409,10.409,0,1,0,266,22.483a10.313,10.313,0,0,0,7.265-2.955V15.261h-7V13.594h8.67v6.613l-.233.242a11.973,11.973,0,0,1-8.7,3.7",
    transform: "translate(-112.854 0.001)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75236",
    "data-name": "Path 75236",
    d: "M145.954,25.405h-.7a9.069,9.069,0,0,1-7.6-4.116l-.563-.864,1.4-.911.563.864a7.4,7.4,0,0,0,6.2,3.36h.7a4.706,4.706,0,0,0,4.7-4.7V18.7a3.038,3.038,0,0,0-.634-1.864,13.1,13.1,0,0,0-3.864-3.145c-.789-.454-1.508-.851-2.162-1.211a31.107,31.107,0,0,1-3.254-1.949l-.095-.069a4.347,4.347,0,0,1-2.122-3.587,5.928,5.928,0,0,1,5.929-5.93h.588A5.924,5.924,0,0,1,149,2.455l1.581,1.417-1.112,1.242L147.887,3.7a4.258,4.258,0,0,0-2.846-1.089h-.588a4.262,4.262,0,0,0-4.262,4.263,2.726,2.726,0,0,0,1.436,2.238l.1.073a30.2,30.2,0,0,0,3.072,1.833c.662.365,1.39.767,2.188,1.226a14.763,14.763,0,0,1,4.346,3.563,4.71,4.71,0,0,1,.987,2.891v.342a6.375,6.375,0,0,1-6.368,6.368",
    transform: "translate(-60.928 -0.418)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75237",
    "data-name": "Path 75237",
    d: "M115.383,79.548c0,.937.882,1.9,2.866,1.9,3.666,0,7.469-2.977,7.469-6.366,0-2.674-3.252-3.693-3.831-3.693-.441,0-1.406.331-2.067.331-.744,0-.993-.276-.993-.578,0-.331.386-.579.993-.579.468,0,1.3.193,1.626.193,2.315,0,9.4-2.922,9.4-7.662,0-3.115-2.646-5.154-8.241-5.154-7.8,0-14.826,4.217-14.826,8.212a2.548,2.548,0,0,0,2.756,2.756,5.649,5.649,0,0,0,1.874-.468.13.13,0,0,1,.138.138,2.793,2.793,0,0,1-2.287.854A3.035,3.035,0,0,1,107,66.181c.083-4.492,7.248-8.929,15.6-8.929,6.146,0,8.957,2.315,8.957,5.815,0,5.071-7.027,7.772-8.378,8.02,0,0,3.252.965,3.252,4,0,3.941-4.079,7.027-8.212,7.027-2.4,0-3.611-1.24-3.611-2.508,0-2.7,3.941-3.941,8.489-3.941.3,0,.523.083.523.248s-.138.22-.523.22c-4.052,0-7.717,1.268-7.717,3.418m8.433-18.686c0,.166-.082.276-.413.441-2.728,1.378-9.756,9.674-9.756,14.5,0,.166-.054.248-.192.248a.573.573,0,0,1-.5-.634c0-5.1,8.847-14.882,10.5-14.882a.361.361,0,0,1,.358.331",
    transform: "translate(-47.556 -25.444)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75238",
    "data-name": "Path 75238",
    d: "M149.534,84.746a2.439,2.439,0,0,1-2.646-2.453c0-2.563,3.417-5.347,5.512-5.347a1.218,1.218,0,0,1,1.378,1.185c0,1.626-3.776,3.169-6.091,3.721a3.371,3.371,0,0,0-.027.523,1.7,1.7,0,0,0,1.874,1.737c3.114,0,5.843-3.28,5.843-3.28s.138-.166.276-.166a.232.232,0,0,1,.248.248.617.617,0,0,1-.138.276s-3.032,3.556-6.229,3.556m-1.653-3.528c2.095-.5,5.236-1.9,5.236-3.17a.545.545,0,0,0-.607-.5c-1.6,0-3.886,1.792-4.63,3.666",
    transform: "translate(-65.282 -34.197)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75239",
    "data-name": "Path 75239",
    d: "M166.581,81.349c-1.075,1.24-3.169,3.252-4.575,3.252a1.331,1.331,0,0,1-1.378-1.433c0-2.7,3.913-6.421,6.917-6.421,1.3,0,1.874.689,1.874,1.378,0,.5-.33.882-.5.882a.146.146,0,0,1-.166-.166,4.891,4.891,0,0,0,.083-.551.923.923,0,0,0-1.047-.937c-3.031,0-6.421,3.555-6.421,5.815,0,.579.276.8.717.8,1.157,0,3-1.736,3.913-2.838.744-.882,1.267-1.736,1.516-1.736a.364.364,0,0,1,.358.358,4.571,4.571,0,0,0-.551,1.792c0,1.019.468,1.488,1.185,1.488.772,0,1.819-.689,3.252-2.287,0,0,.138-.166.248-.166a.255.255,0,0,1,.276.248.617.617,0,0,1-.138.276c-1.543,1.681-2.756,2.508-3.776,2.508-1.047,0-1.792-.937-1.792-2.26",
    transform: "translate(-71.388 -34.108)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75240",
    "data-name": "Path 75240",
    d: "M186.749,83.7a1.681,1.681,0,0,1-1.681-1.654c-.662.634-2.481,2.618-4.107,2.618a1.624,1.624,0,0,1-1.681-1.626c0-2.371,3.5-6.587,3.913-6.587a.42.42,0,0,1,.413.359c0,.082-.083.192-.221.33-.661.717-3.279,3.666-3.279,5.815a.965.965,0,0,0,.992,1.076c1.3,0,2.949-1.737,4.245-3.363.854-1.075,1.543-2.094,2.067-2.728.193-.221.276-.3.386-.3a.444.444,0,0,1,.386.331c0,.083-.056.165-.193.331a26.81,26.81,0,0,0-1.874,2.673,1.988,1.988,0,0,0-.33,1.074,1.044,1.044,0,0,0,1.047,1.047c1.654,0,3.748-2.48,3.748-2.48s.138-.166.276-.166a.248.248,0,0,1,.248.248.617.617,0,0,1-.138.276s-2.4,2.728-4.217,2.728",
    transform: "translate(-79.678 -33.976)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75241",
    "data-name": "Path 75241",
    d: "M198.822,71.4a.225.225,0,0,1-.248-.22c0-.221.441-.662,1.571-.662a16.731,16.731,0,0,1,1.874.166,46.846,46.846,0,0,1,3.225-4.079c.165-.193.3-.276.413-.276a.472.472,0,0,1,.358.386c0,.138-.082.193-.3.469-.358.441-1.626,1.846-2.894,3.61a27.6,27.6,0,0,0,2.756.3q.331,0,.331.166a.584.584,0,0,1-.5.386c-.717,0-1.874-.166-2.976-.3-1.433,2.039-2.756,4.437-2.756,6.422a.9.9,0,0,0,.937.964c1.929,0,4.134-2.618,4.134-2.618s.138-.165.248-.165a.254.254,0,0,1,.276.248.617.617,0,0,1-.138.276s-2.508,2.894-4.768,2.894a1.439,1.439,0,0,1-1.516-1.543c0-1.929,1.323-4.437,2.784-6.587a12.9,12.9,0,0,0-1.626-.138,2.767,2.767,0,0,0-1.186.3",
    transform: "translate(-88.253 -29.479)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75242",
    "data-name": "Path 75242",
    d: "M209.834,84.8c-1.653,4.878-4.575,11.464-9.287,11.464a2.665,2.665,0,0,1-2.866-2.618c0-3.858,6.284-6.2,11.492-9.095.331-1.02.607-1.984.827-2.783-1.543,1.571-3.307,2.866-4.822,2.866a1.57,1.57,0,0,1-1.654-1.682c0-1.956,3.418-6.5,3.858-6.5a.474.474,0,0,1,.386.359c0,.11-.028.138-.166.3-.937,1.129-3.252,4.189-3.252,5.842a.909.909,0,0,0,.993,1.02c1.322,0,2.866-1.1,4.575-3a18.756,18.756,0,0,0,1.929-3.032c.138-.248.248-.386.358-.386a.385.385,0,0,1,.358.358.988.988,0,0,1-.165.358,18.078,18.078,0,0,0-1.709,3.831l-.606,1.929a17.5,17.5,0,0,0,4.437-3.417s.138-.166.248-.166a.255.255,0,0,1,.276.248.616.616,0,0,1-.138.276,20.426,20.426,0,0,1-5.071,3.831m-.937.523c-4.988,2.783-10.527,4.988-10.527,8.3a1.94,1.94,0,0,0,2.095,1.984c4.106,0,6.862-5.677,8.433-10.28",
    transform: "translate(-87.855 -33.976)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75243",
    "data-name": "Path 75243",
    d: "M229.758,77.408c.11-.689,1.378-2.122,2.976-3.968a9.567,9.567,0,0,1-4.051-7.745c0-3.445,1.847-6.145,4.465-6.145,2.287,0,3.611,1.928,3.611,4.988a15.77,15.77,0,0,1-1.268,5.622c2.866-3.445,6.118-10,6.118-12.181,0-.358.192-.579.386-.579s.248.138.248.386c0,2.728-3.142,9.095-7.689,14.359-.248.386-.441.854-.689,1.24a9.13,9.13,0,0,0,4.41,1.129c3.8,0,7.524-2.287,7.524-5.98,0-1.764-.827-2.811-2.371-2.811-1.157,0-1.571.634-1.818.634a.178.178,0,0,1-.166-.165,2.409,2.409,0,0,1,2.122-.992c1.709,0,2.894,1.35,2.894,3.28,0,4.189-3.886,6.67-8.185,6.67a9.167,9.167,0,0,1-4.74-1.213c-1.351,2.2-2.783,3.748-3.417,3.858-.276.055-.386-.166-.358-.386m3.417-4.437.634-.744a17.478,17.478,0,0,0,2.232-7.634c0-2.921-.992-4.41-2.948-4.41-2.233,0-3.721,2.563-3.721,5.512a8.772,8.772,0,0,0,3.8,7.276",
    transform: "translate(-101.634 -25.51)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75244",
    "data-name": "Path 75244",
    d: "M277.112,78.042a1.224,1.224,0,0,1-1.35-1.268c0-1.653,2.673-3.362,2.673-4.465a.39.39,0,0,0-.413-.413c-1.24,0-6.119,3.831-8.379,6.256-.276.3-.468.523-.688.523a.47.47,0,0,1-.441-.413,46.691,46.691,0,0,1,2.425-5.181c2.646-5.071,5.9-9.729,8.681-9.729a1.318,1.318,0,0,1,1.406,1.351c0,2.342-6.393,7.248-9.894,9.977a21.407,21.407,0,0,0-1.516,2.728c1.984-2.177,6.945-6.2,8.544-6.2a1,1,0,0,1,1.047,1.1c0,1.351-2.673,3.17-2.673,4.437,0,.469.248.689.772.689,1.764,0,4.107-2.646,4.107-2.646s.138-.166.276-.166a.231.231,0,0,1,.248.248.613.613,0,0,1-.138.276s-2.508,2.894-4.686,2.894M271.38,73.77c2.838-2.232,8.984-6.972,8.984-9.15a.659.659,0,0,0-.688-.661c-2.261,0-5.567,4.547-8.3,9.811",
    transform: "translate(-119.336 -28.156)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75245",
    "data-name": "Path 75245",
    d: "M296.142,81.349c-1.075,1.24-3.169,3.252-4.574,3.252a1.331,1.331,0,0,1-1.378-1.433c0-2.7,3.913-6.421,6.917-6.421,1.3,0,1.874.689,1.874,1.378,0,.5-.331.882-.5.882a.146.146,0,0,1-.166-.166,4.891,4.891,0,0,0,.083-.551.923.923,0,0,0-1.047-.937c-3.031,0-6.421,3.555-6.421,5.815,0,.579.276.8.717.8,1.157,0,3-1.736,3.913-2.838.744-.882,1.267-1.736,1.516-1.736a.364.364,0,0,1,.358.358,4.571,4.571,0,0,0-.551,1.792c0,1.019.468,1.488,1.185,1.488.772,0,1.819-.689,3.252-2.287,0,0,.138-.166.248-.166a.255.255,0,0,1,.276.248.617.617,0,0,1-.138.276c-1.543,1.681-2.756,2.508-3.776,2.508-1.047,0-1.792-.937-1.792-2.26",
    transform: "translate(-128.969 -34.108)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75246",
    "data-name": "Path 75246",
    d: "M310.885,81.2a1.5,1.5,0,0,1-1.6-1.6c0-1.874,2.866-5.6,3.307-5.6a.313.313,0,0,1,.331.3.534.534,0,0,1-.138.3c-.662.8-2.756,3.39-2.756,4.988a.963.963,0,0,0,1.048,1.019c1.653,0,4.189-2.783,4.189-2.783s.138-.166.248-.166a.254.254,0,0,1,.276.248.613.613,0,0,1-.138.276s-2.646,3-4.768,3m4.63-10.611c0,.386-.386,1.1-.827,1.1a.4.4,0,0,1-.441-.413c0-.468.441-1.074.827-1.074a.393.393,0,0,1,.441.386",
    transform: "translate(-137.457 -31.198)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75247",
    "data-name": "Path 75247",
    d: "M322.862,74.857c.331-.661.854-2.425,1.433-2.425a.586.586,0,0,1,.523.468c0,.413-1.184,1.488-1.184,1.929,0,.193,1.1.854,1.653,1.158.3.138.386.276.386.5,0,1.185-2.4,2.921-2.4,4.52a.818.818,0,0,0,.882.854c1.24,0,2.894-1.433,4.327-3.031,0,0,.138-.166.276-.166a.247.247,0,0,1,.248.248.616.616,0,0,1-.138.276c-1.543,1.681-3.417,3.252-4.878,3.252a1.361,1.361,0,0,1-1.433-1.378c0-1.708,2.287-3.362,2.287-4.409,0-.166-.138-.248-.331-.386a4.145,4.145,0,0,0-1.213-.689c-.11,0-.166.082-.331.3-.413.579-1.626,2.15-2.646,3.307a.484.484,0,0,1-.276.138.225.225,0,0,1-.248-.22.613.613,0,0,1,.138-.276,28.289,28.289,0,0,0,2.921-3.969",
    transform: "translate(-142.131 -32.191)",
    fill: "#767b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75248",
    "data-name": "Path 75248",
    d: "M67.876,37.331l-5.633-7.2L60.93,31.155l4.83,6.176Z",
    transform: "translate(-27.079 -13.39)",
    fill: "#767b74"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24924",
    "data-name": "Group 24924",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75263",
    "data-name": "Path 75263",
    d: "M16.372,31.954s2.405-2.292,3.381-3.176A5.331,5.331,0,0,1,23.338,27.3c1.271.045,2.813.318,3.517.295a1.657,1.657,0,0,0,1.634-1.248,2.755,2.755,0,0,0-.113-1.52c-.136-.386-.306-.567.165-.817s.947-.635.629-1.248a1.358,1.358,0,0,0-.726-.726,1.178,1.178,0,0,0,.976-.839c.227-.771.136-1-.136-1.157s-.658-.544-.25-.885,1.021-.5,1.157-1a1.314,1.314,0,0,0-.567-1.5A5.81,5.81,0,0,1,27.6,13.984c-.2-1.044.25-1.679.272-2.859a6.481,6.481,0,0,0-.839-3.834,16.64,16.64,0,0,0-2.178-2.632,15.653,15.653,0,0,1-4.515,6.671c-3.222,2.587-7.374,4.379-8.3,8.758s-.885,6.512-4.765,8.622A40.343,40.343,0,0,1,0,31.8V0H25.527a15.69,15.69,0,0,1,15.69,15.69v.574a15.69,15.69,0,0,1-15.69,15.69Z",
    transform: "translate(0)",
    fill: "#767b74",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M20.608,15.734H0V6.119A51.375,51.375,0,0,0,9.2,2.983,13.562,13.562,0,0,0,13.417,0V14.22h7.191v1.513Z",
    transform: "translate(0 36.031)",
    fill: "#767b74",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrestigeLogo);
export default __webpack_public_path__ + "static/media/Prestige-logo.f2596a60cd2e66fa592959ee3078554d.svg";
export { ForwardRef as ReactComponent };